import { Component, OnInit } from '@angular/core';
import { DateUtilService } from 'gung-common';
import { LocationConfigService, PriceConfigService } from 'gung-standard';
import { JeevesOrderActionConfigService, JeevesOrderCardListComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'car-liner-order-card-list',
    templateUrl: './car-liner-order-card-list.component.html',
    styleUrls: ['./car-liner-order-card-list.component.scss'],
    standalone: false
})
export class CarLinerOrderCardListComponent extends JeevesOrderCardListComponent implements OnInit {
  partialDeliveryExpected: boolean = false;
  partialEarlyDeliveryDate: Date;

  constructor(
    public configService: JeevesOrderActionConfigService,
    protected locationConfigService: LocationConfigService,
    protected dateUtilService: DateUtilService,
    public priceConfigService: PriceConfigService
  ) {
    super(configService, locationConfigService, priceConfigService);
  }


  ngOnInit(): void {
    for (const row of this.data.rows) {
      const currentDate = new Date(row.extra.orp.ordberlevdat);

      if (!this.partialEarlyDeliveryDate) {
        this.partialEarlyDeliveryDate = currentDate;
      } else {
        if (currentDate < this.partialEarlyDeliveryDate) {
          this.partialDeliveryExpected = true;
          this.partialEarlyDeliveryDate = currentDate;
        }
      }
    }
  }

  getStatusTag(orderStatus: number): string {
    if (orderStatus < 13) {
      return 'ENTRY_IN_PROGRESS';
    } else if (orderStatus === 13) {
      return 'ENTERED';
    } else if (orderStatus >= 14 && orderStatus <= 50) {
      return 'PICKING_IN_PROGRESS';
    } else if (orderStatus === 70) {
      return 'INVOICED';
    }
    return 'UNDEFINED';
  }
}
